// extracted by mini-css-extract-plugin
module.exports = {"mediaCard__details":"ob_JLVD4d","image":"ob_HbINkR"};